import {
  Container,
  Row,
  Col,
  Form,
  ListGroup,
  InputGroup,
  Button,
} from "react-bootstrap";
import CartItemComponent from "../../../components/CartItemComponent";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import QuoeteManagementApproval from "../../../components/SendEmail/QuoeteManagementApproval";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { pdf } from "@react-pdf/renderer";
import CartPrint from "../../../components/Pdfs/CartPrint";
import QuotePrint from "../../../components/Pdfs/QuotePrint";
import axios from "axios";
import "./invoicePDF.css";
import { titleCase } from "../../user/utils/utils";

const AdminCartDetailsPageComponent = ({
  cartItems,
  itemsCount,
  cartSubtotal,
  taxAmount,
  userInfo,
  getAdminDeliveryBooks,
  editQuantity,
  removeFromCart,
  reduxDispatch,
  getUser,
  adminCreateOrder,
  adminCreateQuote,
  getOrdersInvNo,
  emptyCart,
  fetchUsers,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [userAddress, setUserAddress] = useState("");
  const [missingAddress, setMissingAddress] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Invoice");
  const [purchaseNumber, setPurchaseNumber] = useState("");
  const [adminOrderNote, setAdminOrderNote] = useState("");
  const [orderNote, setOrderNote] = useState("");
  const [isStoreUser, setIsStoreUser] = useState(false);
  const [largestInvoice, setLargestInvoice] = useState(0);
  const [users, setUsers] = useState([]);
  const [userNameEmail, setUserNameEmail] = useState();
  const [userName, setUserName] = useState();
  const [managerEmail, setManagerEmail] = useState();
  const [base64Data, setBase64Data] = useState([]);
  const [adminDeliveryBooks, setAdminDeliveryBooks] = useState();
  const [adminDeliverySites, setAdminDeliverySites] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userEmailList, setUserEmailList] = useState([]);
  const [deliverySiteList, setDeliverySiteList] = useState([]);
  const [deliverySiteFinalList, setDeliverySiteFinalList] = useState([]);
  const [deliverySiteListSorted, setDeliverySiteListSorted] = useState([]);
  const [userIdList, setUserIdList] = useState([]);
  const [companyList, setCompanyList] = useState(["-Select Company-"]);
  const [adminSelectedDeliverySite, setAdminSelectedDeliverySite] =
    useState("");
  const [adminSelectedCompany, setAdminSelectedCompany] = useState();
  const [adminSelectedUserName, setAdminSelectedUserName] = useState("");
  const [adminSelectedUserId, setAdminSelectedUserId] = useState();
  const [userInformation, setUserInformation] = useState([]);
  const [quickBooksCustomerId, setQuickBooksCustomerId] = useState();
  const [dueDays, setDueDays] = useState();
  const [userNameList, setUserNamesList] = useState([]);
  const [shippingAddress, setShippingAddress] = useState("");
  const [isDistributor, setIsDistributor] = useState(false);
  const [distributorMarkup, setDistributorMarkup] = useState();
  const [updatedCartItems, setUpdatedCartItems] = useState({ cartItems: [] });
  // const [refreshList, setRefreshList] = useState(false)

  const navigate = useNavigate();

  useEffect(() => {
    getUser()
      .then((data) => {
        setUserNameEmail({
          email: data.email,
          name: data.name,
        });
        setUserName(data.name + " " + data.lastName);
        setUserAddress(data.location);
        // setAdminSelectedDeliverySite(data.location);
        setMissingAddress(false);
      })
      .catch((er) =>
        console.log(
          er.response.data.message
            ? er.response.data.message
            : er.response.data,
        ),
      );
  }, [userInfo._id]);

  useEffect(() => {
    getOrdersInvNo().then((orders) => {
      const invoiceNumbers = orders.map((order) => order.invoiceNumber);
      const newInvoiceNumbers = invoiceNumbers.map((item) => {
        return item.replace(/\D/g, "");
      });

      if (newInvoiceNumbers.length > 0) {
        const filteredInvoiceNumbers = newInvoiceNumbers.filter(
          (num) => num < 165000,
        );
        setLargestInvoice(Math.max(...filteredInvoiceNumbers));
      } else {
        setLargestInvoice(100000);
      }
    });
  }, []);

  useEffect(() => {
    getAdminDeliveryBooks()
      .then((adminDeliveryBooks) => setAdminDeliveryBooks(adminDeliveryBooks))
      .catch((err) =>
        console.log(
          err.response.data.message
            ? err.response.data.message
            : err.response.data,
        ),
      );
  }, []);

  useEffect(() => {
    adminDeliverySites.length = 0;
    adminDeliveryBooks?.map((adminBook) => {
      adminBook.sites?.map((site) => {
        adminDeliverySites?.push(site);
      });
    });
    const tempArray = Array.from(
      new Set(
        adminDeliveryBooks?.map((deliverySite) => deliverySite.companyName),
      ),
    ).sort((a, b) => a.localeCompare(b));

    setCompanyList(Array.from(new Set([...companyList, ...tempArray])));
  }, [adminDeliveryBooks]);

  useEffect(() => {
    const abctrl = new AbortController();
    fetchUsers(abctrl)
      .then((res) => setUsers(res))
      .catch((er) => {
        if (er.code === "ERR_CANCELED") {
        } else if (er.response) {
          console.log(
            er.response.data.message
              ? er.response.data.message
              : er.response.data,
          );
        } else {
          console.log(er);
        }
      });

    return () => abctrl.abort();
  }, [userAddress]);

  const changeCompanyName = (e) => {
    const selectedCompany = e.target.value;

    if (selectedCompany === "-Select Company-") return;

    setAdminSelectedCompany(selectedCompany);

    const companyUsers = users
      ?.filter((user) => user.company === selectedCompany)
      .map((user) => ({
        userName: `${user.name} ${user.lastName} ( ${user.email} ) `,
        userId: user._id,
        userFname: user.name,
        userEmail: user.email,
        deliverySite: user.location?.toUpperCase(),
        isPD: user.isPD === true,
      }))
      .sort((a, b) => a.userName.localeCompare(b.userName));

    const deliverySites = Array.from(
      new Set(companyUsers.map((user) => user.deliverySite)),
    ).sort((a, b) => a.localeCompare(b));

    const firstSite = deliverySites[0];

    const siteUsers = companyUsers.filter(
      (user) => user.deliverySite === firstSite || user.isPD,
    );

    setDeliverySiteListSorted(deliverySites);
    setUserNamesList(siteUsers);

    setAdminSelectedDeliverySite("");
    setAdminSelectedUserName("");
    setAdminSelectedUserId(undefined);
    setUserInformation({});
    setShippingAddress("");

    const selected = selectedCompany?.trim();

    const deliveryBook = adminDeliveryBooks.find(
      (b) => (b.companyName || "").trim() === selected,
    );

    if (!deliveryBook) {
      setIsDistributor(false);
      setDistributorMarkup(0);
      return;
    }

    if (deliveryBook?.isDistributor === true) {
      setIsDistributor(true);
      setDistributorMarkup(deliveryBook.distributorMarkup ?? 0);
    } else {
      setIsDistributor(false);
      setDistributorMarkup(0);
    }
  };

  const changeUserName = (e) => {
    const selectedUserName = e.target.value;

    setAdminSelectedUserName(selectedUserName);

    const selectedUser = users?.find(
      (user) =>
        user.company === adminSelectedCompany &&
        (user.location?.toUpperCase() === adminSelectedDeliverySite ||
          user.isPD === true) &&
        `${user.name} ${user.lastName} ( ${user.email} ) ` === selectedUserName,
    );

    setAdminSelectedUserId(selectedUser?._id);
    setUserInformation({
      name: selectedUser?.name,
      email: selectedUser?.email,
    });
  };

  const changeDeliverySite = (e) => {
    const selectedSite = e.target.value;

    setAdminSelectedDeliverySite(selectedSite);

    const siteUsers = users
      ?.filter(
        (user) =>
          user.company === adminSelectedCompany &&
          (user.location?.toUpperCase() === selectedSite || user.isPD === true),
      )
      .map((user) => ({
        userName: `${user.name} ${user.lastName} ( ${user.email} ) `,
        userId: user._id,
        userFname: user.name,
        userEmail: user.email,
      }))
      .sort((a, b) => a.userName.localeCompare(b.userName));

    setUserNamesList(siteUsers);

    // A still-listed user (e.g. a PD) stays selected in the dropdown, so keep their ID in sync.
    const keptUser = siteUsers.find(
      (user) => user.userName === adminSelectedUserName,
    );
    setAdminSelectedUserName(keptUser?.userName ?? "");
    setAdminSelectedUserId(keptUser?.userId);
    setUserInformation({
      name: keptUser?.userFname,
      email: keptUser?.userEmail,
    });
  };

  const changeCount = (id, qty) => {
    reduxDispatch(editQuantity(id, qty));
  };

  function updateCurrentClientSku(clientsSku) {
    const matchingClientSku = clientsSku?.find((sku) =>
      sku.name
        .match(/[A-Z][a-z]+|[0-9]+/g)
        .join(" ")
        .toLowerCase()
        .includes(adminSelectedDeliverySite.toLowerCase()),
    );

    if (matchingClientSku) {
      return {
        name: matchingClientSku.name,
        number: matchingClientSku.number,
      };
    }

    return {
      name: "",
      number: "",
    };
  }

  useEffect(() => {
    const handleShippingAddress = () => {
      if (!adminSelectedCompany || !adminSelectedDeliverySite) {
        return;
      }

      const selectedCompany = adminDeliveryBooks.find(
        (company) => company.companyName === adminSelectedCompany,
      );
      if (selectedCompany) {
        const selectedSite = selectedCompany.sites.find(
          (site) => site.name === adminSelectedDeliverySite,
        );
        if (selectedSite) {
          setShippingAddress(selectedSite.deliveryAddress);
        }
      }
    };

    handleShippingAddress();
  }, [adminSelectedDeliverySite, adminSelectedCompany, adminDeliveryBooks]);

  const removeFromCartHandler = (productId, quantity, price) => {
    reduxDispatch(removeFromCart(productId, quantity, price));
  };

  useEffect(() => {
    const sourceCartItems = cartItems || [];

    const recalculatedCartItems = sourceCartItems.map((item) => {
      const updatedCartProducts = (item.cartProducts || []).map((p) => {
        const base = isDistributor
          ? Number(p.purchaseprice ?? p.price ?? 0)
          : Number(p.price ?? 0);

        const price = isDistributor
          ? base * (1 + (Number(distributorMarkup) || 0) / 100)
          : base;

        return {
          ...p,
          price: Number(price.toFixed(2)),
        };
      });

      return {
        ...item,
        cartProducts: updatedCartProducts,
      };
    });

    const subtotal = Number(
      recalculatedCartItems
        .reduce(
          (sum, item) =>
            sum +
            (item.cartProducts || []).reduce(
              (s, p) => s + (Number(p.price) || 0) * (Number(p.quantity) || 0),
              0,
            ),
          0,
        )
        .toFixed(2),
    );

    const gst = Number((subtotal * 0.1).toFixed(2));

    const count = recalculatedCartItems.reduce(
      (total, item) =>
        total +
        (item.cartProducts || []).reduce(
          (c, p) => c + (Number(p.quantity) || 0),
          0,
        ),
      0,
    );

    setUpdatedCartItems({
      cartItems: recalculatedCartItems,
      cartSubtotal: subtotal,
      taxAmount: gst,
      itemsCount: count,
    });
  }, [cartItems, isDistributor, distributorMarkup]);

  useEffect(() => {
    const chosenCompany = adminDeliveryBooks?.filter(
      (book) => book.companyName === adminSelectedCompany,
    );
    setQuickBooksCustomerId(
      chosenCompany && chosenCompany[0]?.quickBooksCustomerId,
    );
    setDueDays(chosenCompany && chosenCompany[0]?.dueDays);
  }, [adminSelectedCompany]);

  const choosePayment = (e) => {
    setPaymentMethod(e.target.value);
  };

  const enterPurchaseNum = (e) => {
    setPurchaseNumber(e.target.value);
    setButtonDisabled(false);
  };

  const enterAdminOrderNote = (e) => {
    setAdminOrderNote(e.target.value);
  };

  const enterOrderNote = (e) => {
    setOrderNote(e.target.value);
  };

  const enterManagerEmail = (e) => {
    setManagerEmail(e.target.value + `@${userEmail}`);
  };

  const removeAllItems = () => {
    reduxDispatch(emptyCart());
    setTimeout(() => {
      window.location.href = "/product-list";
    }, 1000);
  };

  const userEmail = userInfo.email?.split("@")[1];

  const generatePdf = async () => {
    try {
      const blob = await pdf(
        <CartPrint
          cartItems={cartItems}
          userInfo={userInformation}
          userAddress={userAddress}
          purchaseNumber={purchaseNumber}
          cartSubtotal={cartSubtotal}
          taxAmount={taxAmount}
        />,
      ).toBlob();

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result;
        setBase64Data({
          base64data,
        });
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Failed to generate PDF:", error);
    }
  };

  useEffect(() => {
    generatePdf();
  }, [cartItems]);

  const quotePriceData = {
    ...userNameEmail,
    cartItems,
    cartSubtotal,
    managerEmail,
    base64Data,
  };

  const nonGSTPrice = Number(
    updatedCartItems?.cartSubtotal || 0,
  ).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const GST = Number(updatedCartItems?.taxAmount || 0).toLocaleString(
    undefined,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  );

  const incGSTPrice = Number(
    (updatedCartItems?.cartSubtotal || 0) + (updatedCartItems?.taxAmount || 0),
  ).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const orderHandler = () => {
    if (adminSelectedDeliverySite === "" || adminSelectedUserName === "") {
      alert("Please Select Delivery Site & User");
    } else {
      const orderData = {
        // orderTotal: {
        //   itemsCount: itemsCount,
        //   cartSubtotal: (updatedCartItems?.cartSubtotal + updatedCartItems?.taxAmount).toFixed(2),
        //   taxAmount: updatedCartItems?.taxAmount,
        // },
        orderTotal: {
          itemsCount: updatedCartItems?.itemsCount || 0,
          cartSubtotal: (
            (updatedCartItems?.cartSubtotal || 0) +
            (updatedCartItems?.taxAmount || 0)
          ).toFixed(2),
          taxAmount: updatedCartItems?.taxAmount || 0,
        },
        cartItems: updatedCartItems?.cartItems.map((item) => {
          const currentClientSku = updateCurrentClientSku(
            item.cartProducts[0].clientsSku,
          );
          return {
            productId: item.productId,
            name: item.name,
            saleunit: item.saleunit,
            image: item.image ? (item.image ?? null) : null,
            cartProducts: [
              {
                attrs: item.cartProducts[0].attrs,
                barcode: item.cartProducts[0].barcode,
                count: item.cartProducts[0].count,
                ctlsku: item.cartProducts[0].ctlsku,
                price: item.cartProducts[0].price,
                purchaseprice: item.cartProducts[0].purchaseprice,
                quantity: item.cartProducts[0].quantity,
                suppliedQty: item.cartProducts[0].quantity,
                backOrder: 0,
                sales: item.cartProducts[0].sales ?? null,
                slrsku: item.cartProducts[0].slrsku,
                suppliersku: item.cartProducts[0].suppliersku,
                clientsSku: item.cartProducts[0].clientsSku,
                currentClientSku: currentClientSku,
                _id: item.cartProducts[0]._id,
                color: item.cartProducts[0].color
                  ? item.cartProducts[0].color
                  : "",
              },
            ],
          };
        }),
        paymentMethod: paymentMethod,
        purchaseNumber: purchaseNumber,
        adminNote: adminOrderNote,
        orderNote: orderNote,
        invoiceNumber: largestInvoice + 1,
        deliverySite: adminSelectedDeliverySite,
        //secondOwnerId: secondOwnerId,
        //storeId: storeUser !== " " ? (storeUser._id) : " ",
        user_id: adminSelectedUserId,
        userName: adminSelectedUserName,
        userCompany: adminSelectedCompany,
        quickBooksCustomerId: quickBooksCustomerId,
        dueDays: dueDays,
      };

      adminCreateOrder(orderData)
        .then(async (data) => {
          if (data) {
            reduxDispatch(emptyCart());
            setTimeout(() => {
              navigate("/admin/orders");
            }, 1000);
            const res = await axios.post("/api/sendemail/newOrderRemind", {
              from: userInfo.email,
              PO: purchaseNumber,
              price: cartSubtotal.toFixed(2),
            });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handleSaveQuote = async () => {
    if (
      adminSelectedCompany &&
      adminSelectedDeliverySite &&
      adminSelectedUserName
    ) {
      const quoteData = {
        userId: adminSelectedUserId,
        userEmail: userInformation.email,
        userName: userInformation.name,

        name: adminSelectedCompany,
        userDescription: `Quote created for ${adminSelectedCompany}`,
        quoteType: "admin",
        createdBy: "admin",

        purchaseNumber,
        cartSubtotal,
        taxAmount,
        userAddress,

        items: updatedCartItems.cartItems.map((item) => {
          const cartProduct = item.cartProducts?.[0];

          return {
            product: item.productId,
            quoteId: item.quoteId || null,
            productName: item.name,
            image: item.image,
            saleunit: item.saleunit || 1,

            quantity: cartProduct?.quantity || item.quantity || 1,
            unitPrice: cartProduct?.price || item.price || 0,
            purchaseprice:
              cartProduct?.purchaseprice || item.purchaseprice || 0,
            totalPrice:
              (cartProduct?.quantity || item.quantity || 1) *
              (cartProduct?.price || item.price || 0),

            ctlsku: cartProduct?.ctlsku || item.ctlsku || "",
            existingProduct: true,
          };
        }),
      };

      const createdQuote = await adminCreateQuote(quoteData);
      alert(createdQuote.message);
    } else {
      alert("Please select Company, Site and User");
    }
  };

  return (
    <>
      <Container>
        <Row className="mt-4">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1>CART DETAILS (ADMIN)</h1>
          </div>
          <Col md={9}>
            <ListGroup>
              <ListGroup.Item className="mt-1">
                <Row>
                  <Col md={4}>
                    <Form.Label className="fw-bold">Company Name:</Form.Label>
                    <Form.Select
                      required
                      name="companyNames"
                      aria-label="Default select example"
                      onChange={changeCompanyName}
                      className="p-0 ps-2"
                    >
                      {companyList &&
                        companyList.map((company, idx) => {
                          return company !== "" ? (
                            <option key={idx} value={company}>
                              {" "}
                              {company}
                            </option>
                          ) : (
                            <option key={idx} value={company}>
                              {" "}
                              {company}
                            </option>
                          );
                        })}
                    </Form.Select>
                  </Col>
                  <Col md={3}>
                    <Form.Label className="fw-bold">Delivery Site:</Form.Label>
                    <Form.Select
                      required
                      name="deliverySites"
                      aria-label="Default select example"
                      onChange={changeDeliverySite}
                      className="p-0 ps-2"
                      value={adminSelectedDeliverySite || ""}
                    >
                      <option value="">-Select Delivery Site-</option>
                      {deliverySiteListSorted &&
                        deliverySiteListSorted
                          .sort((a, b) => a.localeCompare(b))
                          .map((site, idx) => {
                            return site !== "" ? (
                              <option key={idx} value={site}>
                                {" "}
                                {site}
                              </option>
                            ) : (
                              <option key={idx} value={site}>
                                {" "}
                                {site}
                              </option>
                            );
                          })}
                    </Form.Select>
                  </Col>
                  <Col md={5}>
                    <Form.Label className="fw-bold">User's Name:</Form.Label>
                    <Form.Select
                      required
                      name="userNames"
                      aria-label="Default select example"
                      onChange={changeUserName}
                      className="p-0 ps-2"
                      value={adminSelectedUserName || ""}
                    >
                      <option value="">-Select An User-</option>
                      {userNameList &&
                        userNameList
                          .sort((a, b) => a.userName.localeCompare(b.userName))
                          .map((user, idx) => {
                            return user !== "" ? (
                              <option key={idx} value={user.userName}>
                                {" "}
                                {user.userName}
                              </option>
                            ) : (
                              ""
                            );
                          })}
                      {/* {userList &&
                        userList
                          .sort((a, b) => a.userName.localeCompare(b.userName))
                          .map((user, idx) => {
                            return user !== "" ? (
                              <option key={idx} 
                            value={user.userName}
                              >
                                {" "}
                                {user.userName}
                              </option>
                            ) : ("");
                          })} */}
                    </Form.Select>
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>

            <ListGroup.Item className="mt-2">
              <Row>
                <Col md={12}>
                  <ListGroup>
                    {updatedCartItems?.cartItems?.map((item, idx) => (
                      <CartItemComponent
                        item={item}
                        key={idx}
                        changeCount={changeCount}
                        removeFromCartHandler={removeFromCartHandler}
                      />
                    ))}
                  </ListGroup>
                  <Button
                    type="button"
                    onClick={removeAllItems}
                    className="p-1 ps-1 pe-1 mt-1 empty_cart_btn"
                  >
                    Empty Cart <i className="bi bi-trash" />
                  </Button>
                </Col>
              </Row>
            </ListGroup.Item>
          </Col>
          <Col md={3} className="cart_detail_right">
            <ListGroup>
              <ListGroup.Item className="p-1 ps-2">
                <div className="d-grid gap-2">
                  <PDFDownloadLink
                    document={
                      <CartPrint
                        cartItems={updatedCartItems?.cartItems || []}
                        userInfo={userInformation}
                        userAddress={userAddress}
                        purchaseNumber={purchaseNumber}
                        cartSubtotal={updatedCartItems?.cartSubtotal || 0}
                        taxAmount={updatedCartItems?.taxAmount || 0}
                      />
                      // <CartPrint
                      //   cartItems={cartItems}
                      //   userInfo={userInformation}
                      //   userAddress={userAddress}
                      //   purchaseNumber={purchaseNumber}
                      //   cartSubtotal={cartSubtotal}
                      //   taxAmount={taxAmount}
                      // />
                    }
                    fileName={userInformation.name + "'s Cart"}
                    className="btn btn-success p-0 ps-1 pe-1 ms-3 me-3 "
                    style={{
                      padding: "4px 6px",
                      textDecoration: "none",
                    }}
                  >
                    <span>
                      Download Cart <i className="bi bi-file-earmark-pdf"></i>
                    </span>
                  </PDFDownloadLink>
                </div>
              </ListGroup.Item>
            </ListGroup>

            {/* <ListGroup hidden={cartItems.length === 0}>

              <ListGroup.Item controlid="validationMangerEmail" className="p-0">
                <InputGroup className="m-0 p-0">
                  <Form.Control
                    className="p-0 ps-2"
                    onChange={enterManagerEmail}
                    type="string"
                    name="MangerEmail"
                    placeholder={`Enter email`}
                    required
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    style={{ border: "none" }}
                  />
                  <InputGroup.Text
                    id="basic-addon2"
                    className="p-1"
                    style={{ border: "none", borderRadius: "0" }}
                  >
                    @{userEmail}
                  </InputGroup.Text>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Manager's Email.{" "}
                </Form.Control.Feedback>
              </ListGroup.Item>

              <ListGroup.Item className="p-1 ps-2">
                <div className="d-grid gap-2">
                  <QuoeteManagementApproval quotePriceData={quotePriceData} />
                </div>
              </ListGroup.Item>
            </ListGroup> */}

            <br />
            <ListGroup className="">
              <ListGroup.Item className="p-1 ps-2">
                <h4 className="m-0">Order Summary</h4>
              </ListGroup.Item>
              <ListGroup.Item className="p-1 ps-2">
                <p className="p-0 m-0">
                  Total:{" "}
                  <span className="float-end">
                    <span className="fw-bold ">
                      {updatedCartItems?.cartItems?.length || 0}
                    </span>{" "}
                    {updatedCartItems?.cartItems?.length === 1
                      ? "Product"
                      : "Products"}
                    {/* <span className="fw-bold ">{cartItems.length}</span>{" "}
                    {cartItems.length === 1 ? "Product" : "Products"} */}
                  </span>
                </p>
              </ListGroup.Item>

              <ListGroup.Item className="p-1 ps-2">
                Item Price:{" "}
                <span className="fw-bold float-end"> $ {nonGSTPrice}</span>
              </ListGroup.Item>
              <ListGroup.Item className="p-1 ps-2">
                Total GST <span className="fw-bold float-end">$ {GST}</span>
              </ListGroup.Item>
              <ListGroup.Item className="p-1 ps-2">
                Invoice Amount:{" "}
                <span className="fw-bold text-danger float-end">
                  $ {incGSTPrice}
                </span>
              </ListGroup.Item>

              <ListGroup.Item
                controlid="validationSLRPurchaseNum"
                className="p-1 ps-2"
              >
                <Form.Label className="fw-bold text-danger">
                  PO Number
                </Form.Label>
                <Form.Control
                  className="p-0 ps-1"
                  onChange={enterPurchaseNum}
                  type="string"
                  name="SLRPurchaseNumber"
                  placeholder="PO Number"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Purchase Number.{" "}
                </Form.Control.Feedback>
                {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
              </ListGroup.Item>

              <ListGroup.Item
                controlid="validationAdminOrderNote"
                className="p-1 ps-2"
              >
                <Form.Label className="fw-bold">Admin Note:</Form.Label>
                <Form.Control
                  className="p-0 ps-1"
                  type="string"
                  name="adminOrderNote"
                  placeholder="Admin Note"
                  onChange={enterAdminOrderNote}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Note.{" "}
                </Form.Control.Feedback>
              </ListGroup.Item>

              <ListGroup.Item
                controlid="validationOrderNote"
                className="p-1 ps-2"
              >
                <Form.Label className="fw-bold">Order Note:</Form.Label>
                <Form.Control
                  className="p-0 ps-1"
                  type="string"
                  name="orderNote"
                  placeholder="Order Note"
                  onChange={enterOrderNote}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Note.{" "}
                </Form.Control.Feedback>
              </ListGroup.Item>

              <ListGroup.Item
                controlid="validationShippingAddress"
                className="p-1 ps-2"
              >
                <Form.Label className="fw-bold">Shipping Address:</Form.Label>
                <Form.Control
                  as="textarea"
                  className="p-0 ps-1"
                  type="string"
                  name="shippingAddress"
                  placeholder="Shipping Address"
                  required
                  value={titleCase(shippingAddress)
                    .split(",")
                    .map((sentence) => sentence.trim())
                    .join("\n")}
                  style={{ fontSize: "12px", height: "100px" }}
                  disabled
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Shipping Address.{" "}
                </Form.Control.Feedback>
              </ListGroup.Item>

              <ListGroup.Item className="p-1 ps-2">
                <div className="d-grid gap-2">
                  <button
                    size="sm"
                    onClick={orderHandler}
                    disabled={purchaseNumber?.length < 1}
                    className="btn btn-success p-0 ps-1 pe-1"
                    style={{
                      padding: "4px 6px",
                      textDecoration: "none",
                    }}
                  >
                    Confirm Order
                  </button>
                </div>
              </ListGroup.Item>
            </ListGroup>
            <br />
            <ListGroup className="">
              <ListGroup.Item className="p-1 ps-2">
                <h4 className="m-0">Quote Operations</h4>
              </ListGroup.Item>

              <ListGroup.Item className="p-1 ps-2">
                <div className="d-grid gap-2">
                  <PDFDownloadLink
                    document={
                      <QuotePrint
                        cartItems={updatedCartItems?.cartItems || []}
                        userInfo={userInformation}
                        userAddress={userAddress}
                        purchaseNumber={purchaseNumber}
                        cartSubtotal={updatedCartItems?.cartSubtotal || 0}
                        taxAmount={updatedCartItems?.taxAmount || 0}
                        customerName={adminSelectedCompany}
                      />
                      // <QuotePrint
                      //   cartItems={cartItems}
                      //   userInfo={userInformation}
                      //   userAddress={userAddress}
                      //   purchaseNumber={purchaseNumber}
                      //   cartSubtotal={cartSubtotal}
                      //   taxAmount={taxAmount}
                      //   customerName={adminSelectedCompany}
                      // />
                    }
                    fileName={userInformation.name + "'s Cart"}
                    className="btn btn-success p-0 ps-1 pe-1 ms-3 me-3"
                    style={{
                      padding: "4px 6px",
                      textDecoration: "none",
                    }}
                  >
                    <span>
                      Download Quote <i className="bi bi-file-earmark-pdf"></i>
                    </span>
                  </PDFDownloadLink>

                  <Button
                    variant="primary"
                    className="p-0 ps-1 pe-1 ms-3 me-3"
                    onClick={handleSaveQuote}
                  >
                    Save Quote <i className="bi bi-save"></i>
                  </Button>
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AdminCartDetailsPageComponent;
